import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import {
  businessUnitsKeys,
  RequestTypes,
} from '@core/react-query/features/businessUnits'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useDeleteProjectFromBusinessUnit = (
  options?: UseMutationOptions<
    string,
    RequestErrorType,
    RequestTypes['deleteProjectFromBusinessUnit']
  >,
) => {
  return useMutation({
    ...businessUnitsKeys.deleteProjectFromBusinessUnit,
    retry: 0,
    ...options,
  })
}
